import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { AuthenticationServiceService } from '../../services/authentication-service/authentication-service.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(private authService:AuthenticationServiceService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return from(this.authService.getCurrentUser()).pipe(
      mergeMap((userSnap) => {
        // Clone the request and set the Authorization header
        const authReq = request.clone({
          setHeaders: {
            Authorization: `Bearer ${userSnap?.token}`,
          },
        });
        // console.warn("🚀 ~ file: token.interceptor.ts:25 ~ TokenInterceptor ~ mergeMap ~ userSnap?.token:", userSnap?.token)

        // Pass the modified request to the next handler
        return next.handle(authReq);
      })
    );
  }
}
